// src/pages/EducationPage.js
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const EducationPage = ({ language }) => {
  const [programs, setPrograms] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_BASE_URL +
          "continues-training/get-allcontinues-trainings"
      )
      .then((res) => setPrograms(res.data.data));
  }, []);

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4" style={{
        marginTop: "10rem"
      }}>
        {/* Header */}
        <div className="text-center mb-12">
          <button
            onClick={handleBack}
            className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-6 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg mb-6"
          >
            {language === "ar" ? "العودة" : "Back"}
          </button>
          
          <h1 className="text-4xl md:text-5xl font-bold text-green-900 mb-4">
            {language === "ar" ? "جميع برامج التدريب المستمر" : "All Continuing Training Programs"}
          </h1>
          <div className="w-32 h-1 bg-green-600 mx-auto"></div>
          <p className="text-gray-600 max-w-2xl mx-auto mt-4">
            {language === "ar"
              ? "استكشف جميع برامجنا التدريبية المصممة لتطوير مهارات العاملين ورفع كفاءتهم المهنية"
              : "Explore all our training programs designed to develop employee skills and enhance their professional competence"}
          </p>
        </div>

        {/* Programs Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-12">
          {programs.map((program, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-green-700 to-green-800 text-white rounded-xl p-6 shadow-lg transform hover:-translate-y-2 transition-all duration-300"
            >
              <h3 className="font-bold text-lg mb-4">
                {language === "ar" ? program.title_ar : program.title}
              </h3>

              <div className="space-y-3">
                <div className="flex justify-between items-center">
                  <span>
                    {language === "ar" ? "عدد المجموعات:" : "Number of Groups:"}
                  </span>
                  <span className="font-bold text-green-200">
                    {program.groups}
                  </span>
                </div>

                <div className="flex justify-between items-center">
                  <span>
                    {language === "ar"
                      ? "عدد المدربين:"
                      : "Number of Trainers:"}
                  </span>
                  <span className="font-bold text-green-200">
                    {program.trainers}
                  </span>
                </div>

                {/* Additional program details can be added here */}
                {program.duration && (
                  <div className="flex justify-between items-center">
                    <span>
                      {language === "ar" ? "المدة:" : "Duration:"}
                    </span>
                    <span className="font-bold text-green-200">
                      {program.duration}
                    </span>
                  </div>
                )}

                {program.level && (
                  <div className="flex justify-between items-center">
                    <span>
                      {language === "ar" ? "المستوى:" : "Level:"}
                    </span>
                    <span className="font-bold text-green-200">
                      {program.level}
                    </span>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Statistics Section */}
        <div className="bg-green-50 rounded-2xl p-8">
          <h3 className="text-2xl font-bold text-green-900 text-center mb-8">
            {language === "ar"
              ? "إحصائيات التدريب المستمر"
              : "Continuing Training Statistics"}
          </h3>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              {
                number: "3,300+",
                label: { en: "Trained Employees", ar: "موظف مدرب" },
              },
              {
                number: "20+",
                label: { en: "Training Programs", ar: "برنامج تدريبي" },
              },
              {
                number: "95%",
                label: { en: "Satisfaction Rate", ar: "معدل الرضا" },
              },
              {
                number: "10+",
                label: { en: "Training Partners", ar: "شركاء التدريب" },
              },
            ].map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-3xl font-bold text-green-800 mb-2">
                  {stat.number}
                </div>
                <div className="text-green-700">
                  {language === "ar" ? stat.label.ar : stat.label.en}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-6">
            {language === "ar" 
              ? "هل تريد معرفة المزيد عن برامجنا؟ تواصل معنا اليوم!"
              : "Want to learn more about our programs? Contact us today!"}
          </p>
          <button className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-8 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg">
            {language === "ar" ? "تواصل معنا" : "Contact Us"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EducationPage;